import type { FC } from "react";
import React from "react";
import {
  Flex,
  SkeletonBox,
  SkeletonButton,
  SkeletonPlaceholder,
} from "@edreamsodigeo/prisma-design-system";

const EqualProminenceMobileSkeleton: FC = () => (
  <Flex
    flexDirection={"column"}
    data-testid={"equal-prominence-mobile-skeleton"}
  >
    <Flex
      px={"4"}
      py={"3"}
      height={"70px"}
      justifyContent={"space-between"}
      alignItems={"center"}
    >
      <Flex
        alignItems={"flex-start"}
        flexDirection={"column"}
        gap={"2"}
        mt={"1"}
        width={"60%"}
      >
        <SkeletonPlaceholder size={"small"} />
        <SkeletonPlaceholder size={"large"} />
      </Flex>
      <SkeletonButton
        sx={{
          width: "125px",
          height: "44px",
        }}
      />
    </Flex>
    <Flex
      borderTop={1}
      px={"4"}
      py={"3"}
      borderColor={"neutral.50"}
      height={"89px"}
      justifyContent={"space-between"}
      alignItems={"center"}
    >
      <Flex
        alignItems={"flex-start"}
        flexDirection={"column"}
        gap={"2"}
        mt={"1"}
        width={"60%"}
      >
        <SkeletonPlaceholder size={"medium"} />
        <Flex flexDirection={"row"} gap={"2"} width={"100%"}>
          <SkeletonPlaceholder size={"small"} />
          <SkeletonPlaceholder size={"small"} />
        </Flex>
        <SkeletonPlaceholder size={"large"} />
      </Flex>
      <SkeletonButton
        sx={{
          width: "125px",
          height: "44px",
        }}
      />
    </Flex>
    <SkeletonBox width={"100%"} height={"30px"} />
  </Flex>
);

export default EqualProminenceMobileSkeleton;
